// src/services/auth.service.js
/**
 * Gets an Auth0 access token via the secure proxy
 * @returns {Promise<string>} The access token
 */
export const getAuth0Token = async () => {
  // Check if we have a valid token in storage
  const storedToken = localStorage.getItem('auth0_access_token');
  const expiryTime = localStorage.getItem('auth0_token_expiry');
  
  // If the token exists and hasn't expired, return it
  if (storedToken && expiryTime && Date.now() < parseInt(expiryTime)) {
    return storedToken;
  }
  
  // Otherwise, get a new token via the proxy
  try {
    const proxyUrl = process.env.REACT_APP_AUTH_PROXY_URL;
    
    const response = await fetch(proxyUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error('Failed to get Auth0 token from proxy');
    }
    
    const data = await response.json();
    
    // Calculate expiry time and store the token
    const expiryTime = Date.now() + data.expires_in * 1000;
    localStorage.setItem('auth0_access_token', data.access_token);
    localStorage.setItem('auth0_token_expiry', expiryTime.toString());
    
    return data.access_token;
  } catch (error) {
    console.error('Error getting Auth0 token:', error);
    throw error;
  }
};